var _rect, _rect2, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    fill: "none",
    viewBox: "0 0 36 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.96,
    y: 0.5,
    fill: "url(#a)",
    rx: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 0.96,
    y: 0.5,
    stroke: "#EAECF0",
    rx: 17
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.96,
    cy: 17.5,
    r: 9.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D92D20",
    d: "M17.96 27a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19Zm-.95-6.65v1.9h1.9v-1.9h-1.9Zm0-7.6v5.7h1.9v-5.7h-1.9Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 17.96,
    x2: 17.96,
    y1: 0,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EBEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draft-icon.5ebe677be4dd2cdba72e25d04eb75ad6.svg";
export { ForwardRef as ReactComponent };